const Config = {
	default_number_of_bins: "5",
};

export default Config;
